module.exports = "<!--empty by design -->\r\n"